(function(window, angular) {
  "use strict";
  var m = angular.module("vvCommon");

  m.directive('vvAudioSrc', function($timeout) {
    return function(scope, element, attrs) {
      attrs.$observe('vvAudioSrc', function(value) {
        if (!value)
        return;
        var audioElement = element[0];
        var paused = audioElement.paused;
        audioElement.pause();
        attrs.$set('src', value);
        $timeout(function () {
          audioElement.load();
          audioElement.currentTime = 0;
          if (!paused) {
            audioElement.play();
          }
        });
      });
    };
  });
})(window, window.angular);
